import React from 'react'
import { IMkStep } from '@typescript'

// Define StepName enum with all registration step names
// This provides type safety and allows dot notation usage
export enum StepName {
  ACCOUNT_LOOKUP = 'accountLookup',
  USER_DETAILS = 'userDetails',
  CHECK_EMAIL = 'checkEmail',
  SET_PASSWORD = 'setPassword',
  MFA_SETUP_SELECTOR = 'mfaSetupSelector',
  MFA_SETUP_DETAILS = 'mfaSetupDetails',
  MFA_VERIFY_CODE = 'mfaVerifyCode',
  ACCOUNT_LOCK_SCREEN = 'accountLockScreen',
  MFA_CRITICAL_LOCK_SCREEN = 'mfaCriticalLockScreen',
  ACTIVATION_ERROR = 'activationError',
}

// Define the form field structure
export interface RegistrationFormField {
  value: string | null
  isValid: boolean
  validationMessage: string
  required: boolean
  optionLabel?: string
  options?: Array<{ label: string; value: string }>
  feedback?: Array<{ text: string; valid: boolean }>
  type?: string
  errorMessage?: string
}

// Define the form data structure
export type RegistrationFormData = {
  [key in
    | 'activationToken'
    | 'isActivationFlow'
    | 'activationErrorMessage'
    | 'mfaEmail'
    | 'mfaMethod'
    | 'mfaPhoneCode'
    | 'mfaEmailCode'
    | 'mfaFactorId'
    | 'verificationMethod'
    | 'registerAsCompany'
    | 'ownerNumber'
    | 'firstName'
    | 'lastName'
    | 'suffix'
    | 'contractNumber'
    | 'phone'
    | 'companyName'
    | 'email'
    | 'userName'
    | 'password'
    | 'phoneCountry'
    | 'verificationCode']?: RegistrationFormField
}

// Define the registration state structure
export interface RegistrationState {
  formData: RegistrationFormData
  currentStepName: StepName
  registerError: { raw?: Error; message?: string }
  isLoading?: boolean
  registrationToken: string | null
  isSubmitted?: boolean
  stepValidationErrors?: string[]
}

export interface RegisterStep extends IMkStep {
  isVisible: (currentStep: StepName) => boolean
  name: StepName
  props: Record<string, any>
  component?: React.ComponentType<any>
  loader: () => Promise<{ default: React.ComponentType<any> }>
  validation: (formData: RegistrationFormData) => boolean
  apiConfig?: RegisterStepApiConfig
}

// Step registry type
export type RegisterStepRegistry = RegisterStep[]
// API configuration interface
export interface RegisterStepApiConfig {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE'
  endpoint: string | ((formData: RegistrationFormData, registrationToken?: string | null) => string)
  headers?: Record<string, string>
  body?: (formData: RegistrationFormData, registrationToken?: string | null, stateToken?: string | null, selectedFactor?: any) => Record<string, any>
  params?: Record<string, string | null>
  onSuccess?: (data: any) => Promise<void>
}
